module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137512-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_137512-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675026_tableofcontents"
    }
  }, [_vm._v("THE PROBLEM")])]), _vm._v(" "), _c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137512-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "8-1.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_137512-00002"
    }
  }, [_vm._v("The Greeks were wrong about the sun; she is definitely a woman. I know her well. She often visits me, but not often enough. She prefers spending her time on Mediterranean beaches with richer people, foreigners mostly. I never complain. She comes here often enough to keep me hopeful. Until today. Today, perhaps because it is Spring, she arrived unexpectedly in all her glory and made me perfectly happy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137512-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("I was astonished, grateful, and properly appreciative, of course. I lay basking in her golden warmth, a bit dopey and dozey but murmuring the sort of compliments which are appropriate at such times. I realized she was talking to me in a more insistent tone, so I occasionally said, “Yes” and “Mhm”. At last she said, “You aren’t listening.”")])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137512-00004"
    }
  }, [_vm._v("“Yes I am –” (I made an effort of memory) “–You were talking about your spots.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00005"
    }
  }, [_vm._v("“What can I do about them?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00006"
    }
  }, [_vm._v("“Honestly, Sun, I don’t think they’re important.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00007"
    }
  }, [_vm._v("“Not important? "), _c('i', [_vm._v("Not important?")]), _vm._v(" Oh, it’s easy for you to talk like that. You don’t have to live with them.” I almost groaned aloud. Whenever someone makes me perfectly happy they go on to turn themselves into a problem. I gathered my energies to tackle the problem.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00008"
    }
  }, [_vm._v("I said, “Your spots were first noted by Galileo in the sixteenth century, through his new improved telescope. Before that time you were regarded as the most perfect of all heavenly bodies –”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00009"
    }
  }, [_vm._v("She gave a little wail: I said hastily, “But they aren’t permanent! They come and go! They’re associated with several good things, like growth. When you have a very spotty year the plants grow extra fast and thick.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00010"
    }
  }, [_vm._v("She hid her face and said, “Why can’t I have a perfect heavenly body like when I was younger? I haven’t changed. I’m still the same as I was then.” I tried to console her. I said, “Nobody is perfect.” She said nothing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00011"
    }
  }, [_vm._v("I said, “Apart from a few top-level physicists and astronomers, nobody gives a damn for your spots.” She said nothing.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137512-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("I said, “The moon has spots all over her and nobody finds those unattractive.” ")]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("The sun arose and prepared to leave. I gazed at her in horror, too feeble to move, almost too feeble to speak. I whispered, “What’s wrong?”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137512-00013"
    }
  }, [_vm._v("“You’ve just admitted seeing other planets when my back is turned.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00014"
    }
  }, [_vm._v("“Of course, but not deliberately. Everybody who goes out at night is bound to see the moon from time to time, but I don’t see her regularly, like I see you.” She said, “Perhaps if I played hard to get you would find "), _c('i', [_vm._v("my")]), _vm._v(" spots interesting too. What a fool I’ve been to think that give give giving myself seven days a week, fifty-two weeks a year, a hundred years a century was the way to get myself liked and appreciated when all the time people prefer a flighty young bitch who borrows all her light from me! Her own mother! Well, I’ve learned my lesson. From now on I’ll only come right out once a fortnight, then perhaps men will find my spots attractive too.”\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137512-00015"
    }
  }, [_vm._v("And she would have left without another word if I had not jumped up and begged and pleaded and told her a lot of lies. I said a great deal had been discovered about sunspots since Galileo’s day, they were an electromagnetic phenomenon and probably curable. I said that next time we met I would have studied the matter and be able to recommend something. So she left me more in sorrow than anger and I will see her tomorrow.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137512-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-indent_137512-00002"
    }
  }, [_vm._v("But I can never hope to be perfectly happy with her again. The sun is more interested in her spots than in her beams and is ready to blame me for them.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ec937f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675026_chapter_03.vue
// module id = 87
// module chunks = 0